import Big from 'big.js';
import { Format } from 'smg/address';
import axios from 'smg/axios';
import * as session from 'smg/customer-api/session';
import { Escape, Nl2br } from 'smg/html';
import Modal from 'smg/modal';
import * as models from 'smg/models';
import { G } from 'smg/querystring';
import * as template from 'smg/template';
import { DollarFormat } from 'smg/util';
import { Relref } from '../hugo';
import * as lineitems from '../lineitems';
import * as payments from '../payments';
declare interface myWindow extends Window {
    googleReviews: string;
    readonly apiRoot: string;
}
declare const window: myWindow;
declare interface orderResp {
    order: models.Order;
}

export default async function main() {
    const sess = await session.Session().catch(() => undefined);

    function showNotFound() {
        const orderFoundWrapper = document.querySelector('.success-wrapper') as HTMLElement;
        const notFoundWrapper = document.querySelector('.not-found-wrapper') as HTMLElement;
        const bannerContainer = document.querySelector('main') as HTMLElement;

        orderFoundWrapper.classList.add('d-none');
        notFoundWrapper.classList.remove('d-none');
        if (bannerContainer.parentElement) {
            bannerContainer.parentElement.style.backgroundImage = `url("${Relref('/')}bg-banner.png")`;
            bannerContainer.parentElement.style.backgroundSize = 'cover';
            bannerContainer.parentElement.style.marginBottom = '20rem';
            bannerContainer.parentElement.style.height = '500px';
        }
    }

    const tableContainer = document.querySelector('#order-table') as HTMLElement;
    const invoiceNumberEl = document.querySelector('#invoice-number') as HTMLElement;
    const thumbContainer = document.querySelector('#thumb-container');
    const orderTotal = document.querySelector('#order-total') as HTMLElement;
    const orderItems = document.querySelector('#order-items') as HTMLElement;
    const shippingContainer = document.querySelector('#shipping-options-container') as HTMLElement;
    const cartPaymentContainer = document.querySelector('#cart-payment-container') as HTMLElement;
    const poCartPaymentContainer = document.querySelector('#po-cart-payment-container') as HTMLElement;
    const nonPaymentWarning = document.querySelector('#non-payment-warning') as HTMLElement;
    const poNonPaymentWarning = document.querySelector('#po-non-payment-warning') as HTMLElement;
    const cartPaymentWarnIcon = document.querySelector('#warning-icon') as HTMLElement;
    const poCartPaymentWarnIcon = document.querySelector('#po-warning-icon') as HTMLElement;
    const totalNum = document.querySelector('#balance-total') as HTMLElement;
    const poTotalNum = document.querySelector('#po-balance-total') as HTMLElement;
    const paidNum = document.querySelector('#balance-payment') as HTMLElement;
    const poPaidNum = document.querySelector('#po-balance-payment') as HTMLElement;
    const balanceNum = document.querySelector('#balance-remaining') as HTMLElement;
    const poBalanceNum = document.querySelector('#po-balance-remaining') as HTMLElement;
    const makePaymentBtn = document.querySelectorAll('.make-payment-btn');
    const $viewInvoice = document.querySelector('#view-invoice-btn') as HTMLAnchorElement;

    const key = G().Get('id');

    if (!key) {
        showNotFound();
        return;
    }

    axios.get<orderResp>(`/orders/${key}`).
        then(async resp => {
            const order = resp.data.order;

            if (window.googleReviews) {
                const m = new Modal({
                    title: 'Loved your purchase?',
                    text: 'We\'d be thrilled to hear your thoughts! Leave us a Google review and let us know. (This will open a new tab)',
                    confirmButtonClass: 'btn btn-primary text-white rounded',
                    cancelButtonClass: 'btn btn-link text-muted',
                    confirmText: 'Leave a Review!',
                    cancelText: 'No Thank You',
                    onSubmit: () => window.open(window.googleReviews, '_blank'),
                });

                $viewInvoice.href = `${window.apiRoot}/orders/${order.key || ''}/invoice`;

                const modalFooterArr = Array.from(m.Element.querySelectorAll('.modal-footer'));
                const modalFooter = modalFooterArr[0];
                modalFooter.classList.add('d-flex', 'flex-column', 'flex-sm-row');
                const googleReviewIcon = template.Clone('#google-review-logo-template') as HTMLElement;
                googleReviewIcon.firstElementChild?.classList.add('me-sm-auto');

                modalFooter?.insertBefore(googleReviewIcon, modalFooter.firstElementChild);
            }

            const itemQuantity = (arr: models.OrderLineItem[]) => {
                let totalQuantity = 0;

                arr.forEach(lineItem => {
                    if (lineItem.lineItemModel?.product || !lineItem.lineItemModel) {
                        totalQuantity += lineItem.quantity || 0;
                    }
                });

                return totalQuantity;
            };

            tableContainer.append(await lineitems.Table(order.orderLineItems || []));
            invoiceNumberEl.innerText = String(order.invoiceNumber);
            orderTotal.innerText = DollarFormat(order.total || Big('0'));
            orderItems.innerText = String(itemQuantity(order.orderLineItems || []));

            if (order.orderShippingOptions) {
                for (const shippingAddress of order.orderShippingOptions) {
                    const el = template.Clone('#shipping-template');
                    const addressEl = el.querySelector('address') as HTMLElement;

                    if (shippingAddress.shippingOption) {
                        addressEl.innerHTML = Nl2br(Escape(await Format(shippingAddress.shippingOption)));
                    }

                    shippingContainer.append(addressEl);
                }
            }

            for (const orderProof of order.orderProofs || []) {
                const proofEl = template.Clone('#proof-template');
                const imgEl = proofEl.querySelector('img') as HTMLImageElement;
                imgEl.width = 200;
                imgEl.height = 200;
                const anchorEl = proofEl.querySelector('a') as HTMLAnchorElement;

                anchorEl.href = orderProof?.proof?.main || '';
                anchorEl.dataset.caption = orderProof?.proof?.name || '';

                imgEl.src = orderProof?.proof?.thumbnail || '';

                thumbContainer?.append(proofEl);
            }

            const balance = Big(order.balance || 0);
            if (balance.gt('0.05')) {
                makePaymentBtn.forEach(btn => btn.addEventListener('click', () =>
                    payments.PromptPayment(sess, [order.id || ''], balance, false).
                        then(() => window.location.reload()),
                ));
            }

            function hasPo(order: models.Order) {
                if (order.orderPayments) {
                    for (const orderPayment of order.orderPayments) {
                        if (orderPayment.paymentOption) {
                            if (orderPayment.paymentOption.paymentOptionTypeID === models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_PO) {
                                return true;
                            }
                        }
                    }
                    return false;
                }
            }

            if (!hasPo(order) && balance.gt('0.05')) {
                cartPaymentContainer.classList.remove('d-none');
                totalNum.innerText = `$${Big(order.total || '0').toFixed(2)}`;
                paidNum.innerText = `$${Big(order.paid || '0').toFixed(2)}`;
                balanceNum.innerText = `$${Big(order.balance || '0').toFixed(2)}`;
                cartPaymentContainer.classList.add('alert', 'alert-warning', 'w-75');
                cartPaymentWarnIcon.classList.remove('d-none');
                nonPaymentWarning.classList.remove('d-none');
                poCartPaymentContainer.classList.add('d-none');
            } else if (hasPo(order) && balance.gt('0.05')) {
                poCartPaymentContainer.classList.remove('d-none');
                poCartPaymentContainer.classList.add('d-flex');
                poTotalNum.innerText = `$${Big(order.total || '0').toFixed(2)}`;
                poPaidNum.innerText = `$${Big(order.paid || '0').toFixed(2)}`;
                poBalanceNum.innerText = `$${Big(order.balance || '0').toFixed(2)}`;
                poCartPaymentContainer.classList.add('alert', 'alert-success', 'w-75');
                poCartPaymentWarnIcon.classList.remove('d-none');
                poNonPaymentWarning.classList.remove('d-none');
                cartPaymentContainer.classList.remove('alert', 'alert-warning');
                cartPaymentWarnIcon.classList.add('d-none');
                nonPaymentWarning.classList.add('d-none');
                cartPaymentContainer.classList.add('d-none');
            } else {
                poCartPaymentContainer.classList.remove('alert', 'alert-warning');
                poCartPaymentWarnIcon.classList.add('d-none');
                poNonPaymentWarning.classList.add('d-none');
                poCartPaymentContainer.classList.add('d-none');
                cartPaymentContainer.classList.remove('alert', 'alert-warning');
                cartPaymentWarnIcon.classList.add('d-none');
                nonPaymentWarning.classList.add('d-none');
                cartPaymentContainer.classList.add('d-none');
            }

            const spinner = document.querySelector('#spinner');
            const orderContainer = document.querySelector('#order-container');
            spinner?.classList.add('d-none');
            orderContainer?.classList.remove('d-none');
        }).
        catch(err => {
            console.error(err);
            showNotFound();
        });
}